import serviceTypeReducer from './serviceTypeSlice';
import * as serviceTypeActions from './actions';
import * as serviceTypeSelector from './selector';

export {
  serviceTypeActions,
  serviceTypeSelector
}

export default serviceTypeReducer